import React from "react";
import "./About.css";
const SectionTwo = () => {
  return (
    <div className="section-two-about-us">
      <div className="overlay overlay-bold"></div>
      <div className="section-two-inners">
        <h3>Led by a renowned Plastic Surgeon in Gurugram, India</h3>
        <p className="section-two-inner-para">
          Surgery Saathi was established in Gurugram, Delhi, Noida India, at a time when
          there were no dedicated centers for aesthetic surgery offering
          comprehensive services under one roof in the Delhi NCR region. The
          practice quickly became a trendsetter, earning a reputation as the
          best cosmetic surgery clinic in Delhi and introducing the finest
          global practices to India. Through dedication and hard work, it has
          gained respect for delivering exceptional results, with patients
          trusting the clinic to help them achieve their dream bodies.
        </p>
      </div>
    </div>
  );
};

export default SectionTwo;
